export default __webpack_public_path__ + "static/media/9mobile.cef42a87.svg";